import React from 'react';
import classNames from 'classnames';
import styles from './picture.module.scss';
import { SyntheticEvent } from 'react';
import { useState } from 'react';
import { useEffect } from 'react';

export enum PictureMode {
    Portrait = 1,
	Landscape = 2
}

export type PictureSizeProps = {
	/**
    * The URL of the image without any crop
    */
	url: string,
    /**
    * The default width of the image
    */
    width?: number,
    /**
    * The default height of the image
    */
    height?: number,
	/**
	 * Show the image as 1.5x and 2x
	 */
	highRes?: boolean,
	/**
	 * media query
	 */
	media?: string,
    /**
	 * alt
	 */
	alt?: string,
	/**
	 * mimeType
	 */
	mimeType? : string

}

export type PictureProps = {
	 /**
	 * The ALT text for the image
	 */
	 alt?: string,
	 /**
	 * Array of Picture Sizes
	 */
	 sizes: Array<PictureSizeProps>,
	 /**
	 * Should the image be lazy loaded
	 */
	 lazyLoad: boolean,
	 /**
	 * Class name used on main element.
	 */
	 className?: string,
	 /**
	 * AMP page.
	 */
	 isAMP: boolean,

	 height?: number,
	 width?: number,
	 fallback?: string,
	 highRes?: boolean,
	 onLoadCallback?: Function,
};

export function Picture({ alt, sizes, lazyLoad, className, isAMP, height, width, fallback, highRes, onLoadCallback }: PictureProps) {
	const [imgError, setImgError] = useState<boolean>(false);
	const [key, setKey] = useState<string>('');

	useEffect(() => {
		const newKey = pictureUrl(sizes[0], 1);

		if (newKey === key && onLoadCallback) {
			onLoadCallback();
		}
		if (newKey !== key) {
			setKey(newKey);
		}
	}, [sizes]);

	const pictureUrl = (pic : PictureSizeProps, multiplyer : number) => {
		let picWidth = width ? width : pic.width ? pic.width : null;
		//let picHeight = height ? height : pic.height ? pic.height : null;
		return `${pic.url}?${(picWidth ? '&width=' + (picWidth * multiplyer) : '' )}`;
	};

	const onError = () => {
		if(fallback) {
			setImgError(true);
		}
	}

	const onLoad = () => {

		if(onLoadCallback) {
			onLoadCallback();
		}
	}

	if(sizes && sizes.length > 0) {
		return (
			<>
			{isAMP ?
				(
					<div>AMP</div>
				) : (
					<>
						{!imgError && <picture className={ classNames(className)}>
							{sizes.map((item, index) => {
								return(
									<React.Fragment key={index}>
										{item ? (
											(item.highRes || highRes) ?
											(
												<source { ...(item.media && { media: item.media } ) }  srcSet={ `${pictureUrl(item, 1)} 1x, ${pictureUrl(item, 1.5)} 1.5x, ${pictureUrl(item, 2)} 2x` }/>
											) : (
												<source { ...(item.media && { media: item.media } ) } srcSet={ `${pictureUrl(item, 1)}` }/>
											)
										) : (<></>)}
									</React.Fragment>
								);

							})}

							<img
								className={styles.image}
								key={key}
								src={pictureUrl(sizes[0], 1)}
								alt={ (alt ? alt : sizes[0].alt) }  {...(lazyLoad ? {loading: 'lazy'} : {} ) }
								onLoad={onLoad}
								onError={onError}
							/>
						</picture>}
						{imgError && <picture className={ classNames(className)}>
							<img
								className={styles.image}
								src={fallback}
								alt={ (alt ? alt : sizes[0].alt) }  {...(lazyLoad ? {loading: 'lazy'} : {} ) }
								onError={onError}
							/>
						</picture>}
					</>
				)
			}
			</>
		);
	}else{
		return null;
	}
}

export function ParsePictureData(
    {data, width = null, height = null, media = null, highRes = false, alt = null} :
    { data: JSON | object, width: number | null, height: number | null,media: string | null,  highRes: boolean, alt: string | null})
{
    if(data){
        return( { url: data['url'], height: (height ? (height == -1 ? null : height) : data['height']), width: (width ? width : data['width']), highRes: highRes, media, alt } );
    }
}